/**
 * @GestionalePD User layout UI
 */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

//-------------------------------------------------
import { LayoutRoot, LayoutMain } from './dashboardStyles';
import UserHeader from './userHeader';
import Nav from './userSidebar';

/**
 * @returns User Layout UI structure
 */
export default function UserLayout() {
  const [open, setOpen] = useState(false);

  return (
    <LayoutRoot>
      <UserHeader onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <LayoutMain>
        <Outlet />
      </LayoutMain>
    </LayoutRoot>
  );
}
